
import { defineComponent } from 'vue';
import animateScroll from '@/core/scroll/scroll.service';
import viewportEventsService from '@/core/responsive/viewport/viewport-events.service';
import { easeInOutCubic } from '@/core/easing-functions.service';

export default defineComponent({
    name: 'ScrollToTopButton',
    props: {
        text: {
            type: String,
            required: false,
            default: '',
        },
        minDuration: {
            type: Number,
            required: false,
            default: 500,
        },
    },
    setup(props) {
        const scroll: void = () => {
            const scrollDistance = viewportEventsService.viewport.scrollY;
            const duration = Math.max(scrollDistance / 4, props.minDuration);
            animateScroll.animateScroll(0, duration, easeInOutCubic);
        };

        return {
            scroll,
        };
    },
});

